export default {
    PtProduct: { switch: '産品', mainPage: '首頁' },
    PtHeader_products: {
        products: '産品',
        workspace: '工作空間',
        marketPlace: '導航庫中心',
        analytics: '專利數據庫',
        insights: '英策',
        bio: 'Bio',
        chemical: 'Chemical',
        cas: 'CAS',
        discovery: 'Discovery',
        synapse: '新藥情報庫',
        academy: '智慧芽學社',
        course: '智慧芽學社',
        course2b: '企業版學社',
        lab: 'PatSnap Lab',
        open: '開放服務平臺',
        ipAsset: '資産管理',
        allProducts: '産品',
        tffi: 'TFFI',
        eureka: 'Eureka',
        pharmsnap: 'PharmSnap',
        yunchuang: '雲創',
        innoCloud: 'INNOSNAP',
    },
};
